export interface PrivacyArticle {
  title: string;
  content: {
    mainText?: string;
    bulletPoints?: string[];
    additionalText?: string[];
    contactInfo?: string;
  }[];
}

export const privacyPolicyData: PrivacyArticle[] = [
  {
    title: "Politique de confidentialité",
    content: [
      {
        mainText:
          "Cette politique explique comment les données personnelles sont traitées sur le site https://www.espacecadet.com.",
      },
      {
        additionalText: ["Dernière mise à jour : 23 mars 2026."],
      },
    ],
  },
  {
    title: "Responsable de traitement",
    content: [
      {
        bulletPoints: [
          "Responsable de traitement : BAC APPS (Espace Cadet)",
          "SIREN : 790 826 937",
          "Adresse : 5 rue Marguerite de Rochechouart, 75009 Paris, France",
          "Contact RGPD : clementine@espacecadet.com",
        ],
      },
      {
        additionalText: [
          "Next Generation intervient comme prestataire technique et sous-traitant pour les opérations techniques du site.",
        ],
      },
    ],
  },
  {
    title: "Données collectées",
    content: [
      {
        mainText:
          "Via le formulaire de contact, les catégories suivantes peuvent être collectées :",
      },
      {
        bulletPoints: [
          "Identité : nom",
          "Coordonnées : email, téléphone (optionnel)",
          "Contenu de la demande : message libre",
          "Données techniques anti-spam : champ honeypot",
        ],
      },
    ],
  },
  {
    title: "Finalités et bases légales",
    content: [
      {
        bulletPoints: [
          "Répondre aux demandes de contact et de renseignements commerciaux (mesures précontractuelles, article 6.1.b RGPD)",
          "Assurer la sécurité du formulaire et prévenir les abus (intérêt légitime, article 6.1.f RGPD)",
          "Maintenir le fonctionnement technique du site (intérêt légitime, article 6.1.f RGPD)",
        ],
      },
    ],
  },
  {
    title: "Destinataires des données",
    content: [
      {
        bulletPoints: [
          "Équipe habilitée chez Espace Cadet",
          "Prestataires techniques strictement nécessaires au service (hébergement Vercel, envoi d'emails Resend)",
        ],
      },
      {
        additionalText: [
          "Aucune cession commerciale de données personnelles n'est réalisée.",
        ],
      },
    ],
  },
  {
    title: "Transferts hors Union européenne",
    content: [
      {
        mainText:
          "Certains prestataires techniques peuvent traiter des données depuis des pays hors UE.",
      },
      {
        additionalText: [
          "Ces transferts sont encadrés par les mécanismes contractuels appropriés (notamment clauses contractuelles types) lorsque nécessaire.",
        ],
      },
    ],
  },
  {
    title: "Durées de conservation",
    content: [
      {
        bulletPoints: [
          "Demandes de contact : conservation pendant la durée nécessaire au traitement de la demande, puis archivage limité selon les obligations légales et besoins de suivi.",
          "Journaux techniques de sécurité : conservation limitée à la gestion des incidents et de la sécurité.",
        ],
      },
    ],
  },
  {
    title: "Vos droits",
    content: [
      {
        mainText:
          "Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants :",
      },
      {
        bulletPoints: [
          "Accès à vos données",
          "Rectification de vos données",
          "Effacement de vos données",
          "Limitation et opposition au traitement",
          "Portabilité des données lorsque applicable",
        ],
      },
      {
        contactInfo:
          "Pour exercer vos droits : clementine@espacecadet.com (copie possible à contact@next-generation.dev)",
      },
      {
        additionalText: [
          "Vous disposez également du droit d'introduire une réclamation auprès de la CNIL : https://www.cnil.fr/fr/plaintes",
        ],
      },
    ],
  },
  {
    title: "Cookies et traceurs",
    content: [
      {
        mainText:
          "Les règles applicables aux cookies et autres traceurs sont détaillées dans la page dédiée Gestion des cookies.",
      },
    ],
  },
];
